
export const Dashboard = ({
    hasPermission,
}: {
    hasPermission: (pageName: string, featureName?: string) => boolean;
}) => {
    return (
        <div className="p-6 bg-gradient-to-b from-blue-100 via-white to-blue-100 min-h-screen flex items-center justify-center">
            <div className="bg-white shadow-2xl rounded-3xl p-10 text-center max-w-2xl mx-auto transform transition hover:scale-105 hover:shadow-3xl duration-300">
                <h3 className="text-5xl font-extrabold text-blue-700 mb-4">
                    Welcome to Dashboard
                </h3>
                <p className="text-gray-600 text-lg mb-4">
                    Here’s where you can manage all your activities and insights.
                </p>
                <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full mx-auto mt-4"></div>
            </div>
        </div>

    );
};
